<template>
  <div>
    <b-modal
      ref="delete-modal"
      title="Deleting"
      button-size="sm"
      @ok="deleteOk()"
      @cancel="deleteClean()"
    >
      Would you like to delete your account {{ this.deletingAccountId }}?
    </b-modal>
    <b-card no-body>
      <b-tabs pills card vertical>
        <b-tab active>
          <template v-slot:title>
            <span class="nav-icon"><i class="flaticon2-check-mark"></i></span>
            <span class="nav-text">Ads ID</span>
          </template>

          <b-row class="justify-content-end">
            <b-col cols="auto">
              <b-dropdown text="Add account" variant="primary">
                <b-dropdown-item
                  v-for="item in addAccountItems"
                  :key="item.value"
                  @click="addAdsId(item.value)"
                  >{{ item.text }}</b-dropdown-item
                >
              </b-dropdown>
            </b-col>
          </b-row>

          <div v-for="(accountsList, key) in accounts" :key="key">
            <div v-if="accountsList">
              <div class="row">
                <div class="col col-auto">
                  <h2>{{ titles[key] }}</h2>
                </div>
                <div class="col col-auto">
                  <button class="btn btn-default" @click="addAdsId(key)">
                    <i class="ki icon-sm ki-plus pr-0"></i>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <AdsTable
                    :fields="fields"
                    :items="accountsList"
                    :loading="loading"
                    @delete="deleteAdsId"
                    @save="saveId"
                    @status="sendChangeStatusAdsId"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab title="Tracking">
          <template v-slot:title>
            <span class="nav-icon"><i class="flaticon2-check-mark"></i></span>
            <span class="nav-text">Tracking</span>
          </template>
          <b-card-text>
            <p>
              Инструкии по подключению трекинга
            </p>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import AdsTable from "@/components/Domain/Setup/AdsTable";
export default {
  components: { AdsTable },
  data() {
    return {
      loading: false,
      fields: [
        { key: "accountId", label: "ID" },
        { key: "name", label: "Name" },
        { key: "isConfirmed", label: "Confirmed" },
        { key: "status", label: "Status" },
        { key: "delete", label: "Delete" }
      ],
      defaultAdRow: {
        id: 0,
        type: "",
        accountId: "",
        isConfirmed: false,
        name: null,
        status: true,
        isNew: true
      },
      titles: {},
      addAccountItems: [
        {
          text: "Google",
          value: "google"
        },
        {
          text: "Yandex",
          value: "yandex"
        }
      ],
      accounts: {},
      deletingObj: {},
      deletingAccountId: null,
      newAccountId: null,
      newAccountIsConfirmed: false
    };
  },
  computed: {
    selectedDomains() {
      return this.$store.state.auth.selectedDomains;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const { accounts, titles } = await this.$api.domain.getSetup({
          id: this.selectedDomains.map(el => el.id)[0]
        });
        this.accounts = accounts;
        this.titles = titles;
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async sendAdsId(obj) {
      try {
        const { id } = await this.$api.domain.addAdsAccount({
          domainId: this.selectedDomains.map(el => el.id)[0],
          accountId: obj.accountId,
          accountType: obj.type
        });
        this.newAccountId = id;
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async sendRefreshToken(id, token) {
      try {
        const { updated } = await this.$api.domain.setToken({
          id: id,
          refreshToken: token
        });
        this.newAccountIsConfirmed = updated === 1;
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async saveId(obj) {
      // отправка на бэк и получение нового id
      await this.sendAdsId(obj);

      // обновление объекта
      obj.isNew = false;
      obj.id = this.newAccountId;

      // открываем модальное окно с нужным адресом и ждем его завершения
      // по итогу считаем что все успешно и получаем refresh-token
      const refreshToken = "1234567890";
      await this.sendRefreshToken(this.newAccountId, refreshToken);

      obj.isConfirmed = this.newAccountIsConfirmed;

      /*  const googleUser = await this.$gAuth.signIn()
      console.log(googleUser.getId()) // : Get the user's unique ID string.
      console.log(googleUser.getBasicProfile())  // : Get the user's basic profile information.
      console.log(googleUser.getAuthResponse()) // : Get the response object from the user's auth session. access_token and so on*/
      //this.isSignIn = this.$gAuth.isAuthorized

      this.newAccountId = null;
      this.newAccountIsConfirmed = false;
    },
    async sendDeleteAdsId() {
      try {
        await this.$api.domain.deleteAdsAccount({
          id: this.deletingObj.id
        });
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async sendChangeStatusAdsId(obj) {
      try {
        await this.$api.domain.changeStatus({
          id: obj.id,
          status: obj.status
        });
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    addAdsId(type) {
      let obj = Object.assign({}, this.defaultAdRow);
      obj.id = +new Date();
      obj.type = type;

      if (this.accounts[type] === null) {
        this.accounts[type] = [];
      }

      this.accounts[type].push(obj);
    },
    deleteAdsId(adObj) {
      if (adObj.isNew) {
        // новый удаляем без всплывающего окна
        this.deleteFilterOut(adObj.type, adObj.id);
      } else {
        this.deletingObj = adObj;
        this.deletingAccountId = adObj.accountId;
        this.$refs["delete-modal"].show();
      }
    },
    deleteOk() {
      this.sendDeleteAdsId();
      this.deleteFilterOut(this.deletingObj.type, this.deletingObj.id);
      this.deleteClean();
    },
    deleteClean() {
      this.deletingObj = null;
      this.deletingAccountId = null;
    },
    deleteFilterOut(type, id) {
      this.accounts[type] = this.accounts[type].filter(item => item.id !== id);
      if (this.accounts[type].length === 0) {
        this.accounts[type] = null;
      }
    }
  }
};
</script>

<style scoped>
.tab-text-left {
  justify-content: start;
}
.margin-bottom-20 {
  margin-bottom: 20px;
  width: 25%;
}
</style>
